"use client"

import * as React from 'react';
import PackeryGrid from "../components/grids/PackeryGrid";
import {gridRowHeights, gridTypesEnum} from "../utils/SchoolBlocksUtilities";
import {useStores} from "../stores/useStores";
import styles from "./styles/MainGridPage.module.scss"

const MapFixedCollectionPage: React.FC<{
}> = props => {
    const {organizationStore} = useStores();

    return <div id="sb-main-content" className={styles.background}>
        <div id="collection-grid-container">
            {/*@ts-ignore*/}
            <PackeryGrid
                htmlId={'collection-grid'}
                textFilterPlaceholder={"Filter by Title or Category"}
                gridType={gridTypesEnum.LIST_GRID}
                key={organizationStore.currentOrganization.id}
                rowHeight={gridRowHeights.default}
                displayFilterByCategory={typeof organizationStore.currentOrganization.json_data.settings.categoryFilter === "boolean" ?
                    organizationStore.currentOrganization.json_data.settings.categoryFilter : true}
                displayFilterByText={typeof organizationStore.currentOrganization.json_data.settings.textFilter === "boolean" ?
                    organizationStore.currentOrganization.json_data.settings.textFilter : true}
                displayMap={typeof organizationStore.currentOrganization.json_data.settings.displayMap === "boolean" ?
                    organizationStore.currentOrganization.json_data.settings.displayMap : true}
            />
        </div>
    </div>
}

export default MapFixedCollectionPage;
